import './globals'

import React, { Component } from 'react'
import { Route, Switch, Redirect, withRouter } from 'react-router'

import { Layout } from './components/Layout/Layout'
import { Login } from './components/Login/Login'
import { CreateAccount } from './components/CreateAccount/CreateAccount'
import { SetupAccount } from './components/CreateAccount/SetupAccount'
import AccountNotFound from './components/Steps/AccountNotFoundStep/AccountNotFoundStep'
import EmailNotFound from './components/Steps/EmailNotFoundStep/EmailNotFoundStep'
import EmailFound from './components/Steps/EmailFoundStep/EmailFoundStep'
import ForgottenPassword from './components/ForgottenPassword/ForgottenPassword'
import { PlatformSwitch } from './components/PlatformSwitch/PlatformSwitch'

export class App extends Component {
  render() {
    return (
      <Switch>
        <Route exact path="/" component={PlatformSwitch} />
        <Route path="/login/no-account" component={AccountNotFound} />
        <Route path="/login/no-email" component={EmailNotFound} />
        <Route path="/login/email" component={EmailFound} />
        <Layout>
          <Switch>
            <Route path="/login" component={Login} />
            <Route path="/registration" component={CreateAccount} />
            <Route path="/setup" component={SetupAccount} />
            <Route path="/forgotten" component={ForgottenPassword} />
            <Redirect to={{ pathname: '/login', search: this.props.location.search }} />
          </Switch>
        </Layout>
      </Switch>
    )
  }
}

export default withRouter(App)



// WEBPACK FOOTER //
// ./src/App.js